module.exports = __webpack_public_path__ + "static/media/task5Planet4.d98cee5c.png";